import {MenuItems} from "@/types";
import {$t} from "@/lib/helpers/i18nHelper";

export const menuItems: MenuItems = [
  {
    name: "pricing",
    title: $t("Pricing"),
    icon: "mdi-tag",
    class: "page-settings__link",
    activeClass: "__active secondary--text",
    route: { name: "settings/pricing" },
    requiredAuthorities: ["getAnyCurrency", "updateAnyPaymentPackage"],
  },
  {
    name: "payments",
    title: $t("Payment Systems"),
    icon: "mdi-wallet",
    class: "page-settings__link",
    activeClass: "__active secondary--text",
    route: { name: "setting/paymentSystems" },
    requiredAuthorities: ["getAnyCurrency", "getAnyPaymentSystem"],
  },
  {
    name: "currencies",
    title: $t("Currencies"),
    icon: "mdi-cash-multiple",
    class: "page-settings__link",
    activeClass: "__active secondary--text",
    route: { name: "settings/currencies" },
    requiredAuthorities: ["getAnyCurrency", "updateAnyCurrency"],
  },
  // ...(config.featureTags
  //   ? [
  //       {
  //         name: "tags",
  //         title: $t("Categories"),
  //         icon: "mdi-pound",
  //         class: "page-settings__link",
  //         activeClass: "__active secondary--text",
  //         route: { name: "settings/tags" },
  //         requiredAuthorities: ["getAnyCurrency", "updateAnyPaymentPackage"],
  //       },
  //     ]
  //   : []),
];
